import { AbstractApiService } from '../AbstractApiService'

export abstract class AbstractAdminApi extends AbstractApiService {
  abstract version: number

  protected getDsn(): string {
    return import.meta.env.VITE_VUE_ADMIN_API_BASE_URL.replace('{version}', `v${this.version}`)
  }

  protected override getHeaders() {
    return {
      ...super.getHeaders(),
      token: localStorage.token,
      cartToken: localStorage.cart_token,
    }
  }
}
